import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { roleGuard } from './core/guards/role.guard';
import { UserRole } from './core/models/user-role.enum';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () =>
      import('./features/auth/components/login/login.component').then((m) => m.LoginComponent),
  },
  {
    path: 'register',
    loadComponent: () =>
      import('./features/auth/components/register/register.component').then((m) => m.RegisterComponent),
  },
  {
    path: 'register-success',
    loadComponent: () =>
      import('./features/auth/components/register-success/register-success.component').then((m) => m.RegisterSuccessComponent),
  },
  {
    path: '',
    loadComponent: () =>
      import('./shared/components/layout/layout.component').then((m) => m.LayoutComponent),
    canActivate: [authGuard],
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./features/dashboard/components/dashboard/dashboard.component').then(
            (m) => m.DashboardComponent
          ),
      },
      {
        path: 'invoices',
        canActivate: [roleGuard],
        data: { roles: [UserRole.ADMIN] },
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./features/invoices/components/invoice-list/invoice-list.component').then(
                (m) => m.InvoiceListComponent
              ),
          },
          {
            path: ':id',
            loadComponent: () =>
              import('./features/invoices/components/invoice-detail/invoice-detail.component').then(
                (m) => m.InvoiceDetailComponent
              ),
          },
        ],
      },
      {
        path: 'consumption',
        loadComponent: () =>
          import('./features/consumption/components/consumption-dashboard/consumption-dashboard.component').then(
            (m) => m.ConsumptionDashboardComponent
          ),
      },
      {
        path: 'clients',
        canActivate: [roleGuard],
        data: { roles: [UserRole.ADMIN] },
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./features/clients/components/client-list/client-list.component').then(
                (m) => m.ClientListComponent
              ),
          },
          {
            path: 'form',
            loadComponent: () =>
              import('./features/clients/components/clients-form/clients-form.component').then(
                (m) => m.ClientsFormComponent
              ),
          },
          {
            path: 'form/:id',
            loadComponent: () =>
              import('./features/clients/components/clients-form/clients-form.component').then(
                (m) => m.ClientsFormComponent
              ),
          },
          {
            path: ':id',
            loadComponent: () =>
              import('./features/clients/components/client-detail/client-detail.component').then(
                (m) => m.ClientDetailComponent
              ),
          },
        ]
      },
      {
        path: 'plans',
        canActivate: [roleGuard],
        data: { roles: [UserRole.ADMIN] },
        loadComponent: () =>
          import('./features/plans/components/plan-list/plan-list.component').then(
            (m) => m.PlanListComponent
          ),
      },
      {
        path: 'billing',
        canActivate: [roleGuard],
        data: { roles: [UserRole.CLIENTE] },
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./features/billing/components/billing-dashboard/billing-dashboard.component').then(
                (m) => m.BillingDashboardComponent
              ),
          },
          {
            path: 'success',
            loadComponent: () =>
              import('./features/billing/components/billing-success/billing-success.component').then(
                (m) => m.BillingSuccessComponent
              ),
          },
        ],
      },
      {
        path: 'projects',
        canActivate: [roleGuard],
        data: { roles: [UserRole.CLIENTE] },
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./features/projects/components/project-list/project-list.component').then(
                (m) => m.ProjectListComponent
              ),
          },
          {
            path: ':id',
            loadComponent: () =>
              import('./features/projects/components/project-edit/project-edit.component').then(
                (m) => m.ProjectEditComponent
              ),
          },
        ]
      },
    ],
  },
  { path: '**', redirectTo: '' },
];